module.exports = __webpack_public_path__ + "img/agentextensionsimplify.bf0dfa45.png";